module.exports = __webpack_public_path__ + "Poppins-Regular.731a28a413d642522667.ttf";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2demo/src/assets/fonts/Poppins-Regular.ttf
// module id = ../../../../../src/assets/fonts/Poppins-Regular.ttf
// module chunks = main